import {GetProductBulkResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {useCanGoBack, useHistory} from '@aboutyou/router';
import {BackButton, COLORS, Z_INDEXES} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {useAppendFirstProductIdCallback} from '../../../features/firstProductId/useFirstProductIds';

export type GoBackWithCategoryLabelProps = {
  className?: string;
  backLinkTarget?: GetProductBulkResponse['linksSection']['backLinkTarget'];
};

export const GoBackWithCategoryLabelView: FC<GoBackWithCategoryLabelProps> = ({
  backLinkTarget,
  className,
}) => {
  const [pathname, search] = (backLinkTarget?.url || '').split('?');
  const appendFirstProductIdCallback = useAppendFirstProductIdCallback();
  const queryParamsWithFirstProductId = appendFirstProductIdCallback(
    new URLSearchParams(search),
  );
  const backLinkWithFirstProductId = `${pathname}${queryParamsWithFirstProductId}`;

  const canGoBack = useCanGoBack();

  const {goBack} = useHistory();
  const showBackLink = canGoBack || backLinkWithFirstProductId;

  if (!showBackLink) return null;

  const handleGoBack = () => {
    if (canGoBack) {
      goBack();
    }
  };

  return (
    <GoBackButton
      className={className}
      testId={canGoBack ? 'backButton_navigation' : 'backButton_directEntry'}
      href={
        !canGoBack && backLinkWithFirstProductId
          ? backLinkWithFirstProductId
          : undefined
      }
      onClick={handleGoBack}
    />
  );
};

const GoBackButton = styled(BackButton)`
  &&& {
    position: absolute;
    top: 5px;
    left: -2px;
    z-index: ${Z_INDEXES.ADP_BACK_BUTTON};

    svg {
      fill: ${COLORS.Grey1};
    }
  }
`;
